<app-popup-change-user-info [popupInfo]="popupChangeUserInfo"
                            (onVerified)="onVerify()"
                            (close)="closePopup()"></app-popup-change-user-info>
